import { showError } from '@lib/utils';
import { authService } from '@services/auth.service';
import {
  Button, Form, Input, message, Checkbox
} from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { login } from '@redux/auth/authSlice';
import style from './fan-register-form.module.scss';

// Heart badge icon
function HeartIcon() {
  return (
    <svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.8152 9.92514L21.7657 10.8734C21.8993 11.016 22.0615 11.1298 22.2422 11.2076C22.4228 11.2854 22.618 11.3256 22.8152 11.3256C23.0125 11.3256 23.2076 11.2854 23.3883 11.2076C23.5689 11.1298 23.7312 11.016 23.8647 10.8734L22.8152 9.92514ZM31.3708 24.5635L30.3688 25.5585C30.6357 25.8172 30.9957 25.9623 31.3708 25.9623C31.7459 25.9623 32.1059 25.8172 32.3727 25.5585L31.3708 24.5635ZM17.9462 35.0187C12.1398 30.3222 5.22881 25.7115 5.22881 17.0241H2.37695C2.37695 27.3206 10.75 32.8254 16.1324 37.1803L17.9462 35.0187ZM5.22881 17.0241C5.22881 12.7681 7.57113 9.23261 10.7158 7.75794C13.7501 6.33368 17.8454 6.69395 21.7657 10.8753L23.8647 8.97874C19.2295 4.03208 13.8186 3.19581 9.48567 5.22674C5.26303 7.21101 2.37695 11.7862 2.37695 17.0241H5.22881ZM16.1324 37.1803C17.1058 37.9681 18.1515 38.8081 19.2124 39.4446C20.2695 40.0793 21.4863 40.6019 22.8152 40.6019V37.8019C22.243 37.8019 21.5604 37.5723 20.6973 37.0553C19.8379 36.5401 18.9462 35.827 17.9462 35.0187L16.1324 37.1803ZM43.2535 17.0241C43.2535 11.7881 40.3674 7.21288 36.1429 5.23048C31.8119 3.19768 26.401 4.03581 21.7657 8.97874L23.8647 10.8753C27.7851 6.69395 31.8803 6.33368 34.9147 7.75794C38.0593 9.23261 40.4016 12.7681 40.4016 17.0241H43.2535ZM22.3399 28.1121C22.3399 26.3033 23.435 24.7763 24.9446 24.1323C26.3838 23.5182 28.3858 23.6377 30.3688 25.5585L32.3727 23.5686C29.6483 20.9273 26.4219 20.4494 23.8096 21.5638C22.5191 22.125 21.4231 23.0432 20.6556 24.2061C19.8882 25.3691 19.4824 26.7264 19.4881 28.1121H22.3399ZM27.3402 38.7707C27.8687 39.1627 28.4771 39.6089 29.1045 39.9505C29.7319 40.2921 30.5038 40.6019 31.3708 40.6019V37.8019C31.1921 37.8019 30.9183 37.7347 30.4905 37.5033C29.9889 37.2105 29.5075 36.8837 29.0494 36.5289L27.3402 38.7707ZM35.4014 38.7707C36.8559 37.703 38.835 36.3963 40.3826 34.7686C41.9797 33.0905 43.2535 30.9475 43.2535 28.1139H40.4016C40.4016 30.0254 39.5727 31.5187 38.2989 32.8571C36.9775 34.2478 35.3177 35.3342 33.6922 36.5289L35.4014 38.7707ZM33.6922 36.5289C33.234 36.8831 32.7526 37.2092 32.2511 37.5014C31.8233 37.7347 31.5495 37.8019 31.3708 37.8019V40.6019C32.2377 40.6019 33.0077 40.2921 33.6371 39.9486C34.2645 39.6089 34.8729 39.1609 35.4033 38.7726L33.6922 36.5289ZM43.2535 28.1139C43.2589 26.2656 42.5369 24.4848 41.2382 23.1467L39.1754 25.0825C39.9301 25.8571 40.4016 26.9249 40.4016 28.1139H43.2535ZM41.2382 23.1467C40.5907 22.4757 39.8119 21.9398 38.9485 21.5713C38.085 21.2028 37.1547 21.0091 36.2132 21.0019C34.2283 20.9926 32.1807 21.8121 30.3688 23.5686L32.3727 25.5585C33.7226 24.2518 35.0687 23.7963 36.1999 23.8019C37.3464 23.8075 38.4035 24.2873 39.1754 25.0806L41.2382 23.1467ZM41.493 24.7185C42.6668 22.3181 43.2689 19.6868 43.2535 17.0241H40.4016C40.4167 19.2689 39.9094 21.4875 38.9187 23.5107L41.493 24.7185ZM29.0494 36.5289L28.2242 35.9334L26.5397 38.1921L27.3383 38.7707L29.0494 36.5289ZM28.2242 35.9334C25.1328 33.7102 22.3399 31.627 22.3399 28.1121H19.4881C19.4881 33.2771 23.7221 36.1667 26.5397 38.1921L28.2242 35.9334ZM26.5017 35.9614C24.9294 37.171 23.7773 37.8019 22.8152 37.8019V40.6019C24.8743 40.6019 26.7413 39.3345 28.2623 38.1641L26.5017 35.9614Z" fill="white" />
    </svg>

  );
}

function FanRegisterForm() {
  const [requesting, setRequesting] = useState(false);
  const { siteName } = useSelector((state: any) => state.ui);
  const { requireEmailVerification = true } = useSelector((state: any) => state.settings);
  const router = useRouter();
  const dispatch = useDispatch();

  const handleFinish = async (values: any) => {
    try {
      setRequesting(true);
      await authService.register(values);

      if (!requireEmailVerification) {
        message.success(`Thanks for registering${siteName ? ` at ${siteName}` : ''}! Logging you in...`);
        dispatch(login({ username: values.username, password: values.password, redirect: '/' }));
      } else {
        message.success('Please check your inbox and verify your email address', 10);
        router.push('/');
      }
    } catch (e) {
      showError(e);
    } finally {
      setRequesting(false);
    }
  };

  return (
    <div className={style['fan-register-page']}>
      <div className={style['fan-register-card']}>

        {/* Badge */}
        <div className={style.badge} aria-hidden="true">
          <HeartIcon />
        </div>

        {/* Title */}
        <h1 className={style.title}>Fan Sign Up</h1>

        <Form
          name="fan_register"
          initialValues={{ remember: true, gender: 'male' }}
          onFinish={handleFinish}
          scrollToFirstError
        >
          {/* Row 1: First name / Username */}
          <div className={style['fields-grid']}>
            <Form.Item
              name="firstName"
              validateTrigger={['onChange', 'onBlur']}
              rules={[
                { required: true, message: 'Please input your first name!' },
                {
                  pattern: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
                  message: 'First name cannot contain numbers or special characters'
                }
              ]}
            >
              <Input placeholder="First name" maxLength={30} size="large" />
            </Form.Item>

            <Form.Item
              name="username"
              normalize={(v) => v?.toLowerCase()}
              validateTrigger={['onChange', 'onBlur']}
              rules={[
                { required: true, message: 'Please input your username!' },
                { pattern: /^[a-z0-9]+$/g, message: 'Username must contain lowercase alphanumerics only' },
                { min: 3, message: 'Username must contain at least 3 characters' }
              ]}
            >
              <Input placeholder="Username" maxLength={30} size="large" />
            </Form.Item>
          </div>

          {/* Row 2: Last name / Email */}
          <div className={style['fields-grid']} style={{ marginTop: '12px' }}>
            <Form.Item
              name="lastName"
              validateTrigger={['onChange', 'onBlur']}
              rules={[
                { required: true, message: 'Please input your last name!' },
                {
                  pattern: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
                  message: 'Last name cannot contain numbers or special characters'
                }
              ]}
            >
              <Input placeholder="Last name" maxLength={30} size="large" />
            </Form.Item>

            <Form.Item
              name="email"
              validateTrigger={['onChange', 'onBlur']}
              rules={[
                { type: 'email', message: 'Invalid email address!' },
                { required: true, message: 'Please input your email address!' }
              ]}
            >
              <Input placeholder="Email address" size="large" />
            </Form.Item>
          </div>

          {/* Row 3: Display name / Password */}
          <div className={style['fields-grid']} style={{ marginTop: '12px' }}>
            <Form.Item
              name="name"
              validateTrigger={['onChange', 'onBlur']}
              rules={[
                { required: true, message: 'Please input your display name!' },
                { pattern: /^(?=.*\S).+$/g, message: 'Display name cannot be only whitespace' },
                { min: 3, message: 'Display name must contain at least 3 characters' }
              ]}
            >
              <Input placeholder="Display name" maxLength={30} size="large" />
            </Form.Item>

            <Form.Item
              name="password"
              validateTrigger={['onChange', 'onBlur']}
              rules={[
                {
                  pattern: /^(?=.{8,})(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[^\w\d]).*$/g,
                  message: 'Min 8 chars, 1 number, 1 uppercase, 1 lowercase & 1 special character'
                },
                { required: true, message: 'Please enter your password!' }
              ]}
            >
              <Input.Password placeholder="Password" size="large" />
            </Form.Item>
          </div>

          {/* Footer: Checkbox + Button */}
          <div className={style['form-footer']} style={{ marginTop: '16px' }}>
            <Form.Item
              name="agreeToTerms"
              valuePropName="checked"
              style={{ margin: 0 }}
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(new Error('You must agree to the Terms of Service and Privacy Policy'))
                }
              ]}
            >
              <Checkbox>
                <span className={style['terms-text']}>
                  By signing up you agree to our
                  {' '}
                  <Link href="/page/terms-of-service" target="_blank">Terms of Service</Link>
                  {' '}
                  and
                  {' '}
                  <Link href="/page/privacy-policy" target="_blank">Privacy Policy</Link>
                  , and confirm that you are at least 18 years old.
                </span>
              </Checkbox>
            </Form.Item>

            <Form.Item style={{ margin: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                className={style['form-button']}
                disabled={requesting}
                loading={requesting}
                size="large"
              >
                Sign Up
              </Button>
            </Form.Item>
          </div>
        </Form>

      </div>
    </div>
  );
}

export default FanRegisterForm;
